import { BookOpenTextIcon, CalendarCheckIcon, CalendarXIcon, ClipboardCheckIcon, FileTextIcon, FolderSearchIcon, LayersIcon, LayoutGridIcon, MessageSquareIcon, PencilIcon, PencilRulerIcon, ShuffleIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

// =====================================================================
// SLOTS DE IMÁGENES – COMPLETOS (2026-10-23): WebP en Recursos de Impultienda (tienda svenska-klar).
// Si un slot queda vacío, la landing muestra placeholders neutros dibujados con CSS.
// =====================================================================

// SLOT MOCKUP: caja/pila de las 6 volymer SVENSKA KLAR (réplica del mockup de la landing de MATTE KLAR), PNG/WebP transparente.
export const MOCKUP_URL = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c83ef34a-ce43-4acb-b634-a8277893bf0a/1792752207399_svk-mockup-caja-6-volymer-1a07e328.webp';

// SLOT PAGINAS (PAGE_URLS): 5 páginas reales del Volym 1 (Gamma ESTUDIO) para "Titta inuti", mismo orden que pageTexts:
// 1 lärarsida (p12) · 2 elevblad i 3 nivåer (p15) · 3 läsårsplan F–3 (p5) · 4 prov F–6 (p36) · 5 bedömningsmatris (p39)
// Si la página elegida es otra lektion/årskurs, ajustar también title/text en pageTexts.
export const PAGE_URLS: string[] = [
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c83ef34a-ce43-4acb-b634-a8277893bf0a/1792752044284_svk-1-lararsida-p12-fcb6bf11.webp',
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c83ef34a-ce43-4acb-b634-a8277893bf0a/1792752047769_svk-2-elevblad-3nivaer-p15-a418bd7c.webp',
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c83ef34a-ce43-4acb-b634-a8277893bf0a/1792752051746_svk-3-lasarsplan-p05-a40e99c6.webp',
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c83ef34a-ce43-4acb-b634-a8277893bf0a/1792752055451_svk-4-prov-p36-7ab6d041.webp',
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c83ef34a-ce43-4acb-b634-a8277893bf0a/1792752059044_svk-5-bedomningsmatris-p39-4dfd50a1.webp'
];

// ---------- Images ----------
export const PRODUCT_IMAGE = MOCKUP_URL;
export const PRODUCT_IMAGE_ALT = 'SVENSKA KLAR-paketet: sex volymer i svenska för åk 1–9 med lektioner, läsförståelse, skrivande, språklära, övningar inför nationella proven och bedömning';

// ---------- Prices ----------
export const PRICE = '299 kr';
export const ORIGINAL_PRICE = '601 kr';

// ---------- Meta ----------
export const META = {
  title: 'SVENSKA KLAR™ – Färdiga svensklektioner för åk 1–9',
  description: 'Färdigt 6-i-1-system för svenska åk 1–9: 6 volymer, 240 sidor, 12 lektioner minut för minut, läsförståelse och arbetsblad i 3 nivåer, skrivmallar, övningar inför nationella proven, bedömning och 5 bonusar. 299 kr.',
  ogTitle: 'SVENSKA KLAR™ – Gå in i svensklektionen med allt klart',
  ogDescription: 'Hela läsåret i svenska – färdigplanerat. Läsa, skriva, tala och språklära för åk 1–9 med lektioner, lästexter i tre nivåer, skrivmallar och bedömning. Omedelbar nedladdning.'
};

// ---------- Top bar (honest: no countdown) ----------
export const topBar = {
  long: 'Introduktionspris 299 kr · Engångsbetalning · 7 dagars nöjdhetsgaranti',
  short: 'Introduktionspris 299 kr · 7 dagars garanti'
};

// ---------- Section copy ----------
export const copy = {
  ctaDefault: 'Skaffa SVENSKA KLAR™ nu',
  hero: {
    before: 'Få',
    highlight: 'hela läsåret',
    middle: 'i svenska färdigplanerat – kom igång på',
    accent: '5 minuter',
    sub: 'Sluta planera från grunden. Sex digitala volymer för åk 1–9 med färdiga lektioner, läsförståelse, skrivande, tala och språklära, övningar inför nationella proven och bedömning – plus fem bonusar.',
    badgeLine1: '6 volymer',
    badgeLine2: '+ 5 bonusar'
  },
  stats: { title: 'Det kompletta paketet i siffror' },
  difference: {
    kicker: 'Skillnaden med SVENSKA KLAR™',
    titleStart: 'Från stressad lärare till',
    titleAccent: 'trygg och förberedd.',
    intro: 'Tänk dig att börja veckan med svensklektionerna redan organiserade. Du vet vad du ska undervisa om – och du har lektionsupplägget, lästexterna, skrivmallarna, arbetsbladen och facit.',
    beforeLabel: 'Innan SVENSKA KLAR™',
    beforeTitle: 'Känner du igen dig?',
    afterLabel: 'Med SVENSKA KLAR™',
    afterTitle: 'Planera mindre. Undervisa mer.',
    closing: 'Fokusera på dina elever – inte på att skapa allt material själv.'
  },
  recognize: {
    title: 'Har du någonsin upplevt det här?',
    text: 'Om du svarar ja på minst en fråga är SVENSKA KLAR™ för dig.',
    link: 'Du förtjänar ett enklare sätt'
  },
  inside: {
    title: 'Vad innehåller',
    brand: 'SVENSKA KLAR™',
    packTitle: 'Vad gör SVENSKA KLAR™ annorlunda?',
    packText: 'Ett helt läsårs material i svenska – organiserat och redo att använda.'
  },
  pages: {
    kicker: 'Titta inuti SVENSKA KLAR™',
    titleStart: 'Se hur materialet ser ut',
    titleAccent: 'på insidan.',
    text: 'Exempel på sidor ur materialet: lärarsidor minut för minut, elevblad i tre nivåer, läsårsplan, prov och bedömning – skapade för att användas i svenskundervisningen.'
  },
  bonuses: {
    kicker: 'Men det finns mer!',
    titleStart: '5 bonusar',
    titleAccent: 'utan extra kostnad',
    text: 'Fem extra resurser ingår tillsammans med dina sex volymer – så att du kan organisera och genomföra svenskundervisningen ännu enklare.'
  },
  how: {
    titleStart: 'Så fungerar',
    brand: 'SVENSKA KLAR™',
    text: 'Från nedladdning till klassrummet: förbered nästa svensklektion på bara fem minuter.',
    closing: 'Öppna → välj → förbered → undervisa. Enkelt och strukturerat.'
  },
  audience: {
    titleStart: 'För vem är',
    brand: 'SVENSKA KLAR™',
    lead: 'Paketet är för dig som:',
    closing: 'Skapat för lärare som vill lägga mindre tid på förberedelser och mer tid på eleverna.',
    asideTitle: 'Vad är din tid värd?',
    asideLead: 'Tänk på hur många timmar du lägger på planering i svenska varje vecka:',
    asideText: 'Tänk dig nu ett organiserat paket som hjälper dig med allt detta – under hela läsåret.',
    asideClosing: 'Du behöver inte fortsätta börja från noll.'
  },
  offer: {
    titleStart: 'Upptäck ditt kompletta',
    brand: 'SVENSKA KLAR™',
    titleEnd: '-paket',
    text: 'Hela läsåret i svenska – färdigplanerat. Kom igång på 5 minuter.',
    includesLabel: 'Det kompletta paketet innehåller',
    priceLabel: 'Introduktionspris',
    originalLabel: 'Ord. pris',
    oneTime: 'Engångsbetalning. Ingen prenumeration.',
    cta: 'Skaffa hela paketet nu'
  },
  guarantee: {
    title: '7 dagars nöjdhetsgaranti',
    text: 'Ladda ner materialet och se hur det fungerar i din svenskundervisning. Om paketet inte motsvarar dina förväntningar kan du kontakta oss via e-post och begära återbetalning inom 7 dagar från köpet, enligt våra garantivillkor.',
    legal: 'Garantin påverkar inte dina rättigheter enligt gällande konsumentlagstiftning.'
  },
  finalCta: {
    titleStart: 'Din svenskundervisning kan vara',
    titleAccent: 'redo redan idag.',
    text: 'I stället för att leta efter lästexter, skriva frågor och skapa varje arbetsblad själv på kvällarna har du ett organiserat paket i svenska för hela läsåret. Mer tid till det som verkligen betyder något:',
    closing: 'Dina elever. Din undervisning. Ditt liv utanför skolan.',
    recap: ['6 volymer', '5 bonusar', '240 sidor', 'Åk 1–9'],
    oneTime: 'Engångsbetalning – ingen prenumeration.',
    reassurances: ['Omedelbar digital nedladdning', 'Utskrivbara PDF-filer', '7 dagars nöjdhetsgaranti']
  },
  footer: {
    brand: 'SVENSKA KLAR',
    disclaimer: 'SVENSKA KLAR™ är ett fristående undervisningsmaterial i svenska för åk 1–9. Materialet bygger på det centrala innehållet i Lgr22. Övningarna inför nationella proven är egna uppgifter i samma anda – inga officiella prov återges.',
    copyright: '© 2026 SVENSKA KLAR™ · edulabs. Alla rättigheter förbehållna.'
  }
};

// ---------- Data ----------
export const heroGuarantees = ['Omedelbar digital nedladdning', 'Engångsbetalning', 'Ingen prenumeration', '7 dagars nöjdhetsgaranti'];

export const stats = [{
  value: '240',
  label: 'Sidor i huvudvolymerna'
}, {
  value: '6',
  label: 'Digitala volymer i svenska'
}, {
  value: '12',
  label: 'Lektioner minut för minut'
}, {
  value: '100',
  label: 'Färdiga kommentarer till omdömen'
}, {
  value: '5',
  label: 'Bonusar som ingår'
}];

export const differenceStats = [{
  value: 'Åk 1–9',
  label: 'Läsårsplan för F–3, 4–6 och 7–9'
}, {
  value: '6 digitala volymer',
  label: 'Planering, läsförståelse, skrivande, tala och språklära, nationella proven och bedömning'
}, {
  value: 'Utskrivbara PDF-filer',
  label: 'Att använda digitalt eller skriva ut i klassrummet'
}];

export const beforeItems: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Kvällarna försvinner',
  text: 'Timmar framför datorn för att planera nästa veckas svensklektioner – och du är fortfarande inte klar.'
}, {
  title: 'Timmar av letande efter lästexter',
  text: 'Texter från olika webbplatser är för svåra, för enkla eller saknar frågor som passar din årskurs.'
}, {
  title: 'Skrivuppgifterna skapas från grunden',
  text: 'Modelltext, skrivmall, checklista och bedömning – det som skulle ta minuter blir en lång arbetsuppgift.'
}, {
  title: 'Eleverna läser på helt olika nivåer',
  text: 'Några ljudar fortfarande, andra läser kapitelböcker – och alla ska arbeta med samma mål.'
}, {
  title: 'Nationella proven närmar sig',
  text: 'Åk 3, 6 eller 9 – du vill att eleverna känner sig trygga men har inte tid att skapa övningsmaterial.'
}, {
  title: 'Rättning och omdömen tar tid',
  text: 'Elevtexter, läsprotokoll, matriser och omdömen blir ännu mer arbete efter skoltid.'
}];

export const afterItems = ['Ett organiserat paket i svenska för hela grundskolan', 'Läsårsplan för F–3, 4–6 och 7–9', '12 lektioner planerade minut för minut', 'Arbetsblad i 3 nivåer med facit, klara att skriva ut', 'Lästexter i tre nivåer med frågor', 'Skrivmallar för 8 texttyper', 'Övningar inför nationella proven i åk 3, 6 och 9', 'Bedömningsmatriser för läsa, skriva och tala', '100 färdiga kommentarer till omdömen'];

export const recognizeItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: CalendarXIcon,
  title: 'Kvällarna går åt till planering',
  text: 'Sitter du på kvällar och helger och planerar nästa veckas svensklektioner?'
}, {
  icon: FolderSearchIcon,
  title: 'Du letar efter texter på rätt nivå',
  text: 'Söker du ständigt efter lästexter och frågor som passar just dina elever?'
}, {
  icon: LayersIcon,
  title: 'Läsa, skriva, tala och språklära',
  text: 'Ska du hinna med allt det centrala innehållet – och dessutom förbereda eleverna inför nationella proven?'
}, {
  icon: PencilRulerIcon,
  title: 'Du vill slippa skapa allt från noll',
  text: 'Önskar du att lektioner, skrivmallar, arbetsblad och prov redan var förberedda?'
}, {
  icon: ShuffleIcon,
  title: 'Eleverna ligger på olika nivåer',
  text: 'Behöver du uppgifter som fungerar både för elever som behöver stöd och för dem som vill ha mer utmaning?'
}, {
  icon: LayoutGridIcon,
  title: 'Du behöver en tydligare struktur',
  text: 'Vill du ha materialet samlat så att du snabbt hittar det du behöver?'
}];

// Spine colours mirror the box mockup (blue, green, light blue, purple, orange, red).
export const volumes: Array<{
  number: string;
  level: string;
  title: string;
  tagline: string;
  intro: string;
  items: string[];
  outro: string;
  note?: string;
  spine: string;
  rule: string;
}> = [{
  number: 'Volym 01',
  level: 'Planering',
  title: 'Läsårsplan + 12 lektioner minut för minut',
  tagline: 'Gå in i svensklektionen med allt klart.',
  intro: 'Den första volymen ger dig strukturen för hela läsåret och tolv färdiga lektioner på 60 minuter – med lärarsida och elevblad i tre nivåer till varje lektion.',
  items: ['Läsårsplan för F–3, 4–6 och 7–9', 'Terminsplan vecka för vecka', '12-veckorsplan och progressionstabell', '12 lektioner minut för minut (60 min)', 'Lärarsida + elevblad i 3 nivåer', 'Prov', 'Facit (lärarexemplar)', 'Bedömningsmatris'],
  outro: 'Från ”Ljuda och läsa” i åk 1 till ”Analysera en novell” i åk 7–9 – färdigt att undervisa.',
  spine: 'bg-blue-700 text-white',
  rule: 'border-white/30'
}, {
  number: 'Volym 02',
  level: 'Läsa',
  title: 'Läsförståelse och lässtrategier',
  tagline: 'Hjälp eleverna att förstå det de läser.',
  intro: 'Den andra volymen innehåller lässtrategier, lästexter i tre nivåer och färdiga frågor – för skönlitteratur och faktatext.',
  items: ['Lässtrategier före, under och efter läsning', 'Läsa på, mellan och bortom raderna', '18 lästexter i tre nivåer med frågor och facit', 'Skönlitteratur och faktatext', 'Ordförråd i kontext', 'Boksamtal och läslogg', 'Bilder och multimodala texter', 'Källkritik'],
  outro: 'Färdiga texter och frågor som gör läsförståelsen konkret.',
  spine: 'bg-green-600 text-white',
  rule: 'border-white/30'
}, {
  number: 'Volym 03',
  level: 'Skriva',
  title: 'Skrivande och genrer',
  tagline: 'Från tom sida till färdig text – steg för steg.',
  intro: 'Den tredje volymen leder eleverna genom skrivprocessen med modelltexter, skrivmallar och checklistor för åtta texttyper.',
  items: ['Skrivprocessen', 'Cirkelmodellen steg för steg', '8 texttyper med modelltext, skrivmall och checklista', 'Berättande och återberättande text', 'Beskrivande text och faktatext', 'Instruerande och förklarande text', 'Argumenterande text, brev och e-post', 'Kamratrespons', 'Handstil och tangentbord', 'Stavning i egen text'],
  outro: 'Tydliga ramar som gör det lättare för alla elever att skriva.',
  spine: 'bg-sky-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Volym 04',
  level: 'Tala & språk',
  title: 'Tala, lyssna och språklära',
  tagline: 'Muntligt och språkriktigt – utan krångel.',
  intro: 'Den fjärde volymen innehåller färdiga lektioner och arbetsblad för muntlig framställning, samtal och språklära.',
  items: ['Muntlig presentation', 'Samtal och diskussion', 'Aktivt lyssnande', 'Ordklasser och satsdelar', 'Meningsbyggnad och skiljetecken', 'Stavningsregler och ordbildning', 'Ordförråd', 'De nordiska grannspråken', 'De nationella minoritetsspråken', 'Språkets förändring'],
  outro: 'Språklära som eleverna kan använda i sina egna texter.',
  spine: 'bg-purple-600 text-white',
  rule: 'border-white/30'
}, {
  number: 'Volym 05',
  level: 'Inför proven',
  title: 'Inför nationella proven åk 3, 6 och 9',
  tagline: 'Trygga elever inför proven.',
  intro: 'Den femte volymen innehåller egna övningsuppgifter i samma anda som de nationella proven i svenska – inga officiella prov återges.',
  items: ['Åk 3, 6 och 9', 'Läsa skönlitteratur', 'Läsa sakprosa', 'Skriva berättande text', 'Skriva argumenterande text', 'Muntlig uppgift', 'Tidsplan för veckorna före provet', 'Bedömningsstöd och facit'],
  outro: 'Eleverna vet vad som väntar – och du har en färdig plan.',
  note: 'Egna övningsuppgifter. Materialet återger inga officiella nationella prov.',
  spine: 'bg-orange-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Volym 06',
  level: 'Bedömning',
  title: 'Prov, facit & bedömningsmatriser',
  tagline: 'Gör bedömningen enklare och tydligare.',
  intro: 'Den sjätte volymen innehåller prov i två versioner per åk-grupp, facit och färdigt stöd för bedömning och omdömen.',
  items: ['Prov A/B per åk-grupp med facit', 'Bedömningsmatriser för läsa, skriva och tala', 'Åk 3: godtagbara kunskaper', 'Åk 6 och 9: E/C/A', 'Självbedömning och formativ bedömning', 'Läsutvecklingsschema', '100 färdiga kommentarer till omdömen och IUP'],
  outro: 'Mindre tid på rättning – tydligare uppföljning.',
  spine: 'bg-red-600 text-white',
  rule: 'border-white/30'
}];

export const volumesIntro = {
  title: '6 digitala volymer för åk 1–9',
  text: 'Ett komplett paket i svenska – läsa, skriva, tala, lyssna och språklära – som hjälper dig att planera och genomföra undervisningen under hela läsåret. Varje volym innehåller 40 sidor med lektioner, arbetsblad, lästexter, skrivmallar och bedömningsmaterial.'
};

export const packItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: BookOpenTextIcon,
  title: 'Lektioner minut för minut',
  text: 'Slipp börja från ett tomt dokument. 12 lektioner på 60 minuter med lärarsida och elevblad – från åk 1 till åk 9.'
}, {
  icon: FileTextIcon,
  title: 'Arbetsblad i 3 nivåer',
  text: 'Utskrivbara arbetsblad i tre nivåer med facit – så att alla elever kan arbeta mot samma mål.'
}, {
  icon: PencilIcon,
  title: 'Skrivmallar för 8 texttyper',
  text: 'Modelltext, skrivmall och checklista för berättande, faktatext, argumenterande text och mer.'
}, {
  icon: MessageSquareIcon,
  title: 'Läsa, skriva och tala i ett system',
  text: 'Läsförståelse, skrivande, muntlig framställning och språklära samlat – utifrån det centrala innehållet i Lgr22.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Prov A/B med facit',
  text: 'Färdiga prov i två versioner, facit, bedömningsmatriser och övningar inför nationella proven i åk 3, 6 och 9.'
}, {
  icon: CalendarCheckIcon,
  title: 'Läsårsplan',
  text: 'Läsårsplan för F–3, 4–6 och 7–9, terminsplan vecka för vecka och progressionstabell.'
}];

// Textos de las 5 páginas "Titta inuti" = páginas reales del Volym 1 (p12, p15, p5, p36, p39)
const pageTexts: Array<{ label: string; title: string; text: string }> = [{
  label: 'Lärarsida – lektion minut för minut',
  title: 'Lektion 1: Ljuda och läsa – från bokstav till ord (F–1)',
  text: 'En hel lektion på 60 minuter planerad steg för steg – mål, material, minut för minut och vad du säger.'
}, {
  label: 'Elevblad i 3 nivåer',
  title: 'Elevblad till lektion 2: Läsa bilderbok tillsammans (åk 1)',
  text: 'Samma mål i tre nivåer – stöd, standard och utmaning – med facit för läraren.'
}, {
  label: 'Läsårsplan',
  title: 'Läsårsplan F–3',
  text: 'Läsa, skriva, tala och språklära fördelat över läsåret, vecka för vecka.'
}, {
  label: 'Prov med facit',
  title: 'Prov F–6 (version A)',
  text: 'Färdigt prov med 10 uppgifter och poäng – facit (lärarexemplar) ingår för snabb rättning och genomgång.'
}, {
  label: 'Bedömningsmatris',
  title: 'Bedömningsmatris för läsa, skriva och tala',
  text: 'Tydliga nivåer från ”På väg” till ”Mycket väl godtagbart / A” – för läsförståelse, skrivande, argumentation, tal och språkriktighet.'
}];

export const pageSamples: Array<{ src: string; label: string; title: string; text: string }> = pageTexts.map((page, index) => ({
  ...page,
  src: PAGE_URLS[index] || ''
}));

export const pageTypes = ['Lektioner minut för minut', 'Elevblad i 3 nivåer', 'Lästexter och skrivmallar', 'Prov och facit'];

export const bonuses: Array<{
  title: string;
  text: string;
  items: string[];
  benefit: string;
}> = [{
  title: 'Svenska-start på 5 minuter',
  text: '40 korta uppstarter som får igång lektionen direkt – med facit.',
  items: ['10 ordlekar', '10 ”Rätta meningen”', '10 gåtor och rim', '10 ”Dagens ord”'],
  benefit: 'Starta varje svensklektion med fokus – utan extra förberedelse.'
}, {
  title: 'Ordförrådsbanken: 30 färdiga ordövningar',
  text: 'Korta övningar som bygger elevernas ordförråd – för åk 1–9, med facit.',
  items: ['Synonymer', 'Motsatsord', 'Sammansatta ord', 'Ordspråk och uttryck', 'Ord i kontext'],
  benefit: 'Ett rikare ordförråd – i små, färdiga steg.'
}, {
  title: 'Föräldrakommunikation i svenska',
  text: 'Färdiga texter för kontakten med vårdnadshavare under hela läsåret.',
  items: ['Färdiga brev', 'Veckobrev', 'Läsläxa och läslogg för hemmet', 'Information om nationella proven', 'Mall för utvecklingssamtal'],
  benefit: 'Tydlig kommunikation på några minuter.'
}, {
  title: 'Vikariepärm för svenska',
  text: '15 lektioner som vikarien kan genomföra utan förberedelse.',
  items: ['15 färdiga lektioner', 'Instruktioner', 'Arbetsblad', 'Facit'],
  benefit: 'Lugn och ro även när du inte kan vara på plats.'
}, {
  title: 'Affischer för svenskklassrummet',
  text: '20 affischer som gör klassrummet till en lärmiljö.',
  items: ['Alfabetet, vokaler och konsonanter', 'Ordklasser', 'Skiljetecken', 'Skrivprocessen', 'Texttyper', 'Lässtrategier', 'Stor bokstav', 'Stavningsregler', 'Berättelsekartan', 'Ordlista'],
  benefit: 'Skriv ut och sätt upp – direkt.'
}];

export const steps: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Öppna SVENSKA KLAR™',
  text: 'Ladda ner paketet och öppna volymen du behöver – planering, läsförståelse, skrivande, tala och språklära, nationella proven eller bedömning.'
}, {
  title: 'Välj lektion och material',
  text: 'Hitta rätt arbetsområde och välj lektion, lästext, skrivmall eller elevblad i rätt nivå.'
}, {
  title: 'Förbered dig på 5 minuter',
  text: 'Gå igenom lärarsidan och välj det material du behöver.'
}, {
  title: 'Skriv ut och undervisa',
  text: 'Skriv ut elevbladen eller använd materialet digitalt – och gå in i svensklektionen med en tydlig plan.'
}];

export const audienceItems = ['Undervisar i svenska i F–3, 4–6 eller 7–9', 'Är klasslärare och har svenska varje dag', 'Vill ha ett helt läsårs material i svenska organiserat', 'Vill slippa skapa varje arbetsblad från grunden', 'Behöver lästexter och skrivmallar på olika nivåer', 'Vill förbereda eleverna inför nationella proven', 'Vill ha färdiga prov, facit och bedömningsmatriser', 'Vill känna sig bättre förberedd inför undervisningen'];

export const timeValueTasks = ['Leta efter lästexter på rätt nivå', 'Skriva frågor och facit', 'Skapa skrivmallar och checklistor', 'Förbereda inför nationella proven', 'Rätta texter och skriva omdömen'];

export const offerRows: Array<{
  label: string;
  detail: string;
}> = [{
  label: '6 digitala volymer – 240 sidor',
  detail: 'Planering, läsförståelse, skrivande, tala och språklära, nationella proven och bedömning'
}, {
  label: '5 bonusar utan extra kostnad',
  detail: 'Svenska-start, ordförrådsbanken, föräldrakommunikation, vikariepärm och affischer'
}, {
  label: 'För åk 1–9',
  detail: '12 lektioner minut för minut, arbetsblad i 3 nivåer, lästexter, skrivmallar och prov A/B med facit'
}];

export const offerIncludes = ['Omedelbar digital nedladdning', 'PDF-filer att spara', 'Utskrivbara arbetsblad', 'Ingen fysisk produkt skickas'];

// No buyers yet: only add authentic reviews of SVENSKA KLAR. The section stays hidden while empty.
export const testimonials: Array<{
  quote: string;
  name: string;
  location: string;
}> = [];

export const faqs = [{
  q: 'Hur får jag materialet?',
  a: 'SVENSKA KLAR™ levereras digitalt. Efter köpet får du tillgång till PDF-filer som du kan ladda ner och spara. Du kan använda materialet på dator, surfplatta eller mobil och skriva ut de sidor du behöver.'
}, {
  q: 'Vad ingår i de sex volymerna?',
  a: 'Volym 1: läsårsplan och 12 lektioner minut för minut. Volym 2: läsförståelse. Volym 3: skrivande och genrer. Volym 4: tala, lyssna och språklära. Volym 5: inför nationella proven. Volym 6: bedömning.'
}, {
  q: 'Vilka årskurser passar det för?',
  a: 'SVENSKA KLAR™ är för åk 1–9, med extra mycket material för F–6. Du får läsårsplaner för F–3, 4–6 och 7–9 och väljer material utifrån den årskurs du undervisar i.'
}, {
  q: 'Bygger materialet på Lgr22?',
  a: 'Ja. SVENSKA KLAR™ bygger på det centrala innehållet i kursplanen i svenska i Lgr22: läsa och skriva, tala, lyssna och samtala, berättande texter och faktatexter, språkbruk samt informationssökning och källkritik. SVENSKA KLAR™ är ett fristående undervisningsmaterial.'
}, {
  q: 'Är det de nationella proven?',
  a: 'Nej. Volym 5 innehåller egna övningsuppgifter i samma anda som de nationella proven i svenska i åk 3, 6 och 9 – läsa, skriva och en muntlig uppgift. Inga officiella prov återges.'
}, {
  q: 'Kan jag verkligen förbereda en lektion på 5 minuter?',
  a: 'SVENSKA KLAR™ är utformat för att göra lektionsförberedelserna snabbare. Du kan öppna en volym, välja en färdig lektion eller ett elevblad och gå igenom lärarsidan på ungefär fem minuter. Tiden kan variera beroende på lektionsinnehåll och elevgrupp.'
}, {
  q: 'Räcker materialet för ett helt läsår?',
  a: 'SVENSKA KLAR™ innehåller läsårsplaner och material som kan användas under hela läsåret. Du väljer, kombinerar och anpassar resurserna efter din planering och elevernas behov.'
}, {
  q: 'Ingår facit?',
  a: 'Ja. Arbetsblad, lästexter och prov har facit. Proven finns i version A och B, och paketet innehåller även bedömningsmatriser, självbedömning och 100 färdiga kommentarer till omdömen.'
}, {
  q: 'Kan jag använda materialet för elever på olika nivåer?',
  a: 'Ja. Arbetsbladen och lästexterna finns i tre nivåer, så att du kan ge alla elever uppgifter som passar deras kunskaper och behov.'
}, {
  q: 'Är filerna utskrivbara?',
  a: 'Ja. Allt levereras som utskrivbara PDF-filer. Du väljer själv vilka sidor du skriver ut, och du kan även använda delar av materialet digitalt.'
}, {
  q: 'Ingår de fem bonusarna?',
  a: `Ja. Alla fem bonusar ingår i paketet utan extra kostnad – allt för ${PRICE}.`
}, {
  q: 'Är det en prenumeration?',
  a: 'Nej. Du betalar en gång och får tillgång till det digitala materialet. Inga återkommande avgifter.'
}, {
  q: 'Kan jag använda materialet på mobil eller surfplatta?',
  a: 'Ja. PDF-filerna kan öppnas på dator, surfplatta och mobil. För att granska layouten före utskrift rekommenderar vi dator eller surfplatta.'
}, {
  q: 'Finns det någon garanti?',
  a: 'Ja. SVENSKA KLAR™ har 7 dagars nöjdhetsgaranti. Om materialet inte motsvarar dina förväntningar kan du kontakta oss och begära återbetalning inom 7 dagar från köpet enligt villkoren.'
}];

export const footerLinks = ['Köpvillkor', 'Integritetspolicy', 'Återbetalningspolicy', 'Kontakt'];
